import { render, staticRenderFns } from "./OfficesVehicleInspectionsList.vue?vue&type=template&id=4b4ff35b&scoped=true&"
import script from "./OfficesVehicleInspectionsList.vue?vue&type=script&lang=js&"
export * from "./OfficesVehicleInspectionsList.vue?vue&type=script&lang=js&"
import style0 from "./OfficesVehicleInspectionsList.vue?vue&type=style&index=0&id=4b4ff35b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4ff35b",
  null
  
)

export default component.exports